import { render, staticRenderFns } from "./BtnSelectWashVial.desktop.vue?vue&type=template&id=5b0dff36&scoped=true&"
import script from "./BtnSelectWashVial.desktop.vue?vue&type=script&lang=js&"
export * from "./BtnSelectWashVial.desktop.vue?vue&type=script&lang=js&"
import style0 from "./BtnSelectWashVial.desktop.vue?vue&type=style&index=0&id=5b0dff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0dff36",
  null
  
)

export default component.exports